import React, { Component } from 'react';
import styles from './color.less.js';
import { evaluate, ColorFrom, ColorPicker, CustomSketch } from '@tencent/workbench';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import Dropdown from '@tencent/dui/lib/components/Dropdown';
import { ColorOperations } from '../../../services/form.interface.js';
import { rgbaToHexA } from './rgba-to-hexa.js';

class ColorPickerPanel extends Component {
    constructor(props) {
        var _a;
        super(props);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : '#FF0000';
        this.handleVisiableChange = (visiable) => {
            this.setState({
                showColorPicker: visiable,
            });
        };
        this.state = {
            showColorPicker: false,
        };
    }
    render() {
        const tooltipText = evaluate(this.props.tooltip, null);
        let value = evaluate(this.props.value, this.value);
        const options = evaluate(this.props.options, {});
        const hexA = rgbaToHexA(value);
        if (hexA.alpha === 1) {
            value = hexA.hex; // 避免ColorPicker组件出现相同的两个最新使用颜色，如#ff0000和rbga(255,0,0,1)
        }
        const noAlphaColor = (options === null || options === void 0 ? void 0 : options.isColorNoAlpha) ? hexA.hex : value;
        const dropdownContentProps = {
            selected: noAlphaColor,
            onChange: (color, from) => {
                this.handleColorChange(color, from);
            },
            onColorEnter: (color, from) => {
                this.handleColorChange(color, from, ColorOperations.COLOR_ENTER);
            },
            onPanelLeave: () => {
                this.handleColorChange('', ColorFrom.NONE, ColorOperations.PANEL_LEAVE);
            },
            recentColorsText: options === null || options === void 0 ? void 0 : options.recentColorsText,
        };
        if (options.customContent) {
            dropdownContentProps.customContent = React.createElement("div", { onClick: () => this.handleVisiableChange(false) }, options.customContent);
        }
        return (React.createElement(Tooltip, { title: tooltipText, disabled: !tooltipText, className: styles.tooltip, hideOnClick: true },
            React.createElement("div", { className: styles['palette-buttons'] },
                React.createElement(Dropdown, { dropContent: React.createElement(Dropdown.Keep, null,
                        React.createElement(ColorPicker, Object.assign({}, dropdownContentProps))), visible: this.state.showColorPicker, onVisibleChange: this.handleVisiableChange },
                    React.createElement("div", { className: styles['palette-color-box'], style: { backgroundColor: noAlphaColor } })),
                React.createElement(Dropdown, { dropContent: React.createElement(Dropdown.Keep, null,
                        React.createElement(CustomSketch, { colour: value, onChange: color => this.handleColorChange(color, ColorFrom.CUSTOM), style: {
                                backgroundColor: 'rgb(255, 255, 255)',
                                padding: '12px 10px',
                                border: '1px solid rgba(0, 0, 0, 0.04)',
                                boxShadow: 'rgb(0 0 0 / 12%) 0px 2px 6px 0px',
                                borderRadius: '1px',
                            } })) },
                    React.createElement("div", { className: styles['palette-icon-container'] },
                        React.createElement("div", { className: styles['palette-icon'] },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16" },
                                React.createElement("g", { fill: "none" },
                                    React.createElement("path", { d: "M0 0h16v16H0z" }),
                                    React.createElement("path", { d: "M11.6 8c-.533 0-1-.467-1-1 0-.533.467-1 1-1 .533 0 1 .467 1 1 0 .532-.467 1-1 1ZM9.8 5.4c-.533 0-1-.467-1-1 0-.533.467-1 1-1 .533 0 1 .467 1 1 0 .533-.467 1-1 1ZM6.4 5.4c-.534 0-1-.467-1-1 0-.533.466-1 1-1 .533 0 1 .467 1 1 0 .533-.467 1-1 1ZM4.4 8c-.534 0-1-.467-1-1 0-.533.466-1 1-1 .533 0 1 .467 1 1 0 .532-.467 1-1 1Z", fill: "currentColor" }),
                                    React.createElement("path", { d: "M8 1.516h-.002A6.456 6.456 0 0 0 1.516 8 6.456 6.456 0 0 0 8 14.484c.345 0 .664-.32.664-.664 0-.199-.038-.298-.223-.496-.285-.422-.398-.666-.398-1.056 0-.897.768-1.663 1.664-1.663h1.397a3.343 3.343 0 0 0 3.38-3.381c0-3.138-2.88-5.708-6.484-5.708Zm.001-1h.001H8h.001Z", stroke: "currentColor" })))))))));
    }
    handleColorChange(color, from = ColorFrom.NONE, isMouseEnter) {
        var _a, _b;
        if (!isMouseEnter) {
            this.handleVisiableChange(false);
            this.value = color;
            this.forceUpdate();
        }
        (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, color, from, isMouseEnter);
    }
}

export { ColorPickerPanel };
//# sourceMappingURL=color.js.map
